import { Action } from '@foodsby/nutrient'
import { values } from 'lodash'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { change, destroy, reduxForm, unregisterField } from 'redux-form'

import {
  addItemToCartStart,
  clearMenuItemsForEdit,
  editOrderInCart,
} from '../../redux/modules/cart'
import { clearError } from '../../redux/modules/checkout'
import { getFavoriteCommentsStart, loadHashesStart } from '../../redux/modules/favorite'
import { loadFriendsFavorites } from '../../redux/modules/friends'
import {
  changeMenuAnswer,
  clearPersonalize,
  getDescendantQuestionIds,
  loadMenuItemStart,
} from '../../redux/modules/personalize'
import {
  getDisplayedQuestions,
  orderSubtotal,
  personalizeFormErrors,
} from '../../redux/modules/selectors'
import { pushAnalyticsEvent } from '../../util/gtmUtils'
import { SimpleSpinner } from '../common/SimpleSpinner'
import Favorite from '../community/Favorite'
import FavoritePersonalizePanel from '../community/FavoritePersonalizePanel'
import FriendsFavorites from './FriendsFavorites'
import PersonalizeOrderForm, { formName, questionPrefix } from './PersonalizeOrderForm'

const scrollToTop = event => {
  event.preventDefault()
  document.getElementById('personalize-order').scrollIntoView({ behavior: 'smooth' })
}

const PersonalizeOrderFormContainer = reduxForm({
  form: formName,
})(PersonalizeOrderForm)

export class PersonalizeOrder extends Component {
  state = {
    favoriteSelected: false,
    friendsFavoritesSelected: false,
    personalizeSelected: true,
  }
  componentDidMount() {
    const {
      getFavoriteCommentsStart,
      isAuthenticated,
      loadFriendsFavorites,
      loadHashesStart,
      loadMenuItemStart,
      menuId,
      menuItemId,
    } = this.props
    loadMenuItemStart(menuItemId)
    if (isAuthenticated) {
      loadHashesStart(menuItemId)
      getFavoriteCommentsStart(menuId, menuItemId)
      loadFriendsFavorites(menuItemId)
    }
    pushAnalyticsEvent('Ordering', 'Personalize Menu Item', undefined, menuItemId)
  }

  componentWillUnmount() {
    const { clearMenuItemsForEdit, clearPersonalize, destroy } = this.props
    destroy(formName)
    clearMenuItemsForEdit()
    clearPersonalize()
  }

  handleClick = e => {
    const newState = {
      favoriteSelected: false,
      friendsFavoritesSelected: false,
      personalizeSelected: false,
    }
    newState[e] = true
    this.setState(() => newState)
  }

  radioChange = (event, changeMenuAnswer, questions, answers) => {
    let targetQuestions = getDescendantQuestionIds(event.questionId, questions, answers)
    this.resetChildFormQuestions(targetQuestions)
    event.descendants = targetQuestions
    changeMenuAnswer(event)
  }

  checkboxChange = (event, changeMenuAnswer, questions, answers) => {
    if (!event.selected) {
      let targetQuestions = []
      answers[event.answerId].questions.forEach(questionId => {
        targetQuestions.push(
          questionId,
          ...getDescendantQuestionIds(questionId, questions, answers),
        )
      })
      this.resetChildFormQuestions(targetQuestions)
      event.descendants = targetQuestions
    }
    changeMenuAnswer(event)
  }

  resetChildFormQuestions = questionIds => {
    const { change } = this.props
    questionIds.forEach(id => {
      change(formName, `${questionPrefix}${id}`, '')
      unregisterField(formName, `${questionPrefix}${id}`)
    })
  }

  addItemsToCart = (itemValues, checkout) => {
    const { addItemToCartStart, dropoffId, location, menuItemId } = this.props
    addItemToCartStart(location.deliveryLocationId, menuItemId, dropoffId, itemValues, checkout)
  }

  editOrder = (itemValues, checkout) => {
    const {
      clearError,
      dropoffId,
      editOrderInCart,
      isEditingFromMenu,
      location,
      menuItemForEdit,
    } = this.props

    checkout && clearError()

    editOrderInCart(
      location.deliveryLocationId,
      menuItemForEdit.menuItemId,
      dropoffId,
      itemValues,
      menuItemForEdit.orderItemId,
      isEditingFromMenu,
      checkout,
    )
  }

  render() {
    const {
      answers,
      changeMenuAnswer,
      displayedQuestions,
      favoriteComments,
      friendsFavorites,
      hashes,
      isAuthenticated,
      isCartSaving,
      isEditingFromCheckout,
      isEditingFromMenu,
      isEditingOrder,
      isEditingPastOrder,
      isLoadingComments,
      loading,
      location = {},
      menuId,
      menuItem,
      menuItemForEdit,
      menuItemId,
      orderCartError,
      orderSubtotal,
      orderCartTotal,
      checkoutCartTotal,
      orderCartLength,
      checkoutCartLength,
      editedOrderItemPrice,
      requiredQuestionsAnswers,
      personalizeError,
      questions,
    } = this.props
    const filteredFriendsFavorites =
      friendsFavorites &&
      friendsFavorites.map(a => ({
        favorites: a.configurations.filter(fav => fav.menuItemId === menuItemId),
        firstName: a.firstName,
        lastName: a.lastName,
        userId: a.userId,
      }))
    return (
      <Fragment>
        {loading ? (
          <SimpleSpinner />
        ) : (
          <div>
            {(menuItem || menuItemForEdit) && (
              <div>
                <div className="row center-xs">
                  <div className="col-xs">
                    <h1 className="title" id="personalize-order" style={{ position: 'relative' }}>
                      <Favorite
                        className="personalizeFavorite"
                        id={menuItemId}
                        menuId={menuId}
                        parentComponentName="Menu Customization Modal"
                      />
                      {menuItem.text}
                    </h1>
                    <p className="description">{menuItem.description}</p>
                  </div>
                </div>
                {isAuthenticated && !isEditingFromCheckout && !isEditingFromMenu && (
                  <div className="personalizeModalBanner">
                    <button
                      className={this.state.personalizeSelected ? 'link selected' : 'link'}
                      onClick={() => this.handleClick('personalizeSelected')}
                    >
                      Personalize
                    </button>

                    <button
                      className={this.state.favoriteSelected ? 'link selected' : 'link'}
                      onClick={() => this.handleClick('favoriteSelected')}
                    >
                      Your Orders ({(hashes && hashes.length) || 0})
                    </button>
                    <button
                      className={this.state.friendsFavoritesSelected ? 'link selected' : 'link'}
                      onClick={() => this.handleClick('friendsFavoritesSelected')}
                    >
                      Friends Orders (
                      {friendsFavorites && friendsFavorites.length > 0
                        ? friendsFavorites.map(a => a.configurations.length).reduce((a, b) => a + b)
                        : 0}
                      )
                    </button>
                  </div>
                )}
                {this.state.favoriteSelected ? (
                  <FavoritePersonalizePanel
                    favoriteComments={
                      favoriteComments &&
                      favoriteComments.filter(comment => comment.menuItemId === menuItemId)
                    }
                    friendsFavorites={friendsFavorites}
                    hashes={
                      hashes &&
                      hashes.filter(
                        (hash, index, self) =>
                          self.findIndex(t => {
                            return t.hash === hash.hash
                          }) === index,
                      )
                    }
                    isLoadingComments={isLoadingComments}
                    menuId={menuId}
                    menuItemId={menuItemId}
                  />
                ) : this.state.personalizeSelected ? (
                  <div>
                    <PersonalizeOrderFormContainer
                      answers={answers}
                      checkoutCartLength={checkoutCartLength}
                      checkoutCartTotal={checkoutCartTotal}
                      destroyOnUnmount={false}
                      displayedQuestions={displayedQuestions}
                      editedOrderItemPrice={editedOrderItemPrice}
                      enableReinitialize={!isEditingPastOrder}
                      initialValues={menuItemForEdit && isEditingOrder ? menuItemForEdit : null}
                      isAuthenticated={isAuthenticated}
                      isCartSaving={isCartSaving}
                      isEditingFromCheckout={isEditingFromCheckout}
                      isEditingFromMenu={isEditingFromMenu}
                      isEditingOrder={isEditingOrder}
                      locationId={location.deliveryLocationId}
                      menuItemForEdit={menuItemForEdit}
                      onCheckboxChange={event =>
                        this.checkboxChange(event, changeMenuAnswer, questions, answers)
                      }
                      onRadioChange={event =>
                        this.radioChange(event, changeMenuAnswer, questions, answers)
                      }
                      onSubmit={
                        isEditingOrder && (isEditingFromCheckout || isEditingFromMenu)
                          ? this.editOrder
                          : this.addItemsToCart
                      }
                      orderCartLength={orderCartLength}
                      orderCartTotal={orderCartTotal}
                      orderSubtotal={orderSubtotal}
                      personalizeFormError={orderCartError || personalizeError}
                      questions={questions}
                      requiredQuestionsAnswers={requiredQuestionsAnswers}
                    />
                    <div className="personalize-up_wrapper">
                      <div className="personalize-up_inner-wrapper">
                        <Action
                          className="footer-up personalize-up"
                          onClick={scrollToTop}
                          title="scroll to top"
                        >
                          <i className="icon icon-angle-up" />
                        </Action>
                      </div>
                    </div>
                  </div>
                ) : (
                  this.state.friendsFavoritesSelected && (
                    <FriendsFavorites
                      {...{
                        filteredFriendsFavorites,
                        friendsFavorites,
                      }}
                    />
                  )
                )}
              </div>
            )}
          </div>
        )}
      </Fragment>
    )
  }
}

PersonalizeOrder.defaultProps = {
  menuItem: { questions: [] },
}

const mapStateToProps = state => {
  const { error, loading } = state.personalize
  let menuItems = {},
    questions,
    answers,
    result
  if (state.personalize.normalizedMenuItem) {
    // eslint-disable-next-line no-extra-semi
    ;({
      entities: { answers, menuItems, questions },
      result,
    } = state.personalize.normalizedMenuItem)
  }
  const {
    checkoutCart,
    isCartSaving,
    isEditingPastOrder,
    menuItemForEdit,
    orderCart,
    orderCartError,
  } = state.cart
  const { friendsFavorites } = state.friends
  const { favoriteComments, isLoadingComments } = state.favorite
  const { isAuthenticated } = state.user
  const { location } = state.location
  const editedItem = orderCart.orderItems.find(orderItem => {
    if (orderItem && orderItem.orderItemId && menuItemForEdit && menuItemForEdit.orderItemId) {
      return orderItem.orderItemId === menuItemForEdit.orderItemId
    }
    return false
  })

  const requiredQuestions = values(state.personalize.normalizedMenuItem.entities.questions)
    .filter(question => question.minimumSelection > 0)
    .map(question => `q_${question.id}`)

  let requiredQuestionsAnswers = {}
  requiredQuestions.forEach(question =>
    personalizeFormErrors(state)
      ? (requiredQuestionsAnswers[question] = personalizeFormErrors(state)[question])
      : (requiredQuestionsAnswers[question] = undefined),
  )

  return {
    answers,
    checkoutCartLength: checkoutCart.orderItems.length,
    checkoutCartTotal: checkoutCart.itemSubTotal,
    displayedQuestions: getDisplayedQuestions(state),
    editedOrderItemPrice: editedItem && editedItem.fullSubTotal,
    favoriteComments,
    friendsFavorites,
    isAuthenticated,
    isCartSaving,
    isEditingPastOrder,
    isLoadingComments,
    loading,
    location,
    menuItem: menuItems[result],
    menuItemForEdit,
    orderCartError,
    orderCartLength: orderCart.orderItems.length,
    orderCartTotal: orderCart.itemSubTotal,
    orderSubtotal: orderSubtotal(state),
    personalizeError: error,
    questions,
    requiredQuestionsAnswers,
  }
}

const mapDispatchToProps = {
  addItemToCartStart,
  change,
  changeMenuAnswer,
  clearError,
  clearMenuItemsForEdit,
  clearPersonalize,
  destroy,
  editOrderInCart,
  getFavoriteCommentsStart,
  loadFriendsFavorites,
  loadHashesStart,
  loadMenuItemStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalizeOrder)
